const React = require('react');
const { createElement: h, useEffect, useRef, useState } = React;
require('./ClassifierEditor.css');

function parseLabels(raw) {
  return String(raw || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean);
}

function ClassifierEditor(props) {
  var title = props.title || 'Classifier';
  var initialParams = props.initialParams || {};
  var position = props.position || { left: 0, top: 0, side: 'left' };
  var onClose = props.onClose;
  var onSave = props.onSave;
  var hideInstruction = props.hideInstruction || false;
  var labelsTitle = props.labelsTitle || 'Classification Labels';
  var settingsTitle = props.settingsTitle || 'Classifier Settings';
  var popoverRef = useRef(null);
  var newLabelRef = useRef(null);

  var [labels, setLabels] = useState(function() {
    var parsed = parseLabels(initialParams.labels);
    return parsed.length ? parsed : ['positive', 'negative', 'neutral'];
  });
  var [newLabel, setNewLabel] = useState('');
  var [instruction, setInstruction] = useState(
    initialParams.instruction !== undefined ? String(initialParams.instruction) : ''
  );

  useEffect(function() {
    function onDocumentMouseDown(event) {
      if (!popoverRef.current) return;
      if (!popoverRef.current.contains(event.target)) onClose();
    }
    function onDocumentKeyDown(event) {
      if (event.key === 'Escape') onClose();
    }
    document.addEventListener('mousedown', onDocumentMouseDown);
    document.addEventListener('keydown', onDocumentKeyDown);
    return function() {
      document.removeEventListener('mousedown', onDocumentMouseDown);
      document.removeEventListener('keydown', onDocumentKeyDown);
    };
  }, [onClose]);

  function addLabel() {
    var trimmed = newLabel.trim();
    if (!trimmed) return;
    if (labels.indexOf(trimmed) >= 0) return;
    setLabels(labels.concat(trimmed));
    setNewLabel('');
    setTimeout(function() { if (newLabelRef.current) newLabelRef.current.focus(); }, 0);
  }

  function removeLabel(index) {
    setLabels(labels.filter(function(_, i) { return i !== index; }));
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') { e.preventDefault(); addLabel(); }
  }

  function handleSave() {
    if (!labels.length) return;
    onSave({
      labels: labels.join(','),
      instruction: instruction.trim()
    });
  }

  return h(
    'div',
    {
      ref: popoverRef,
      className: 'clf-editor-popover clf-editor-popover-' + (position.side || 'left'),
      style: { left: (position.left || 0) + 'px', top: (position.top || 0) + 'px' },
      onMouseDown: function(event) { event.stopPropagation(); }
    },
    h('div', { className: 'clf-editor-arrow' }),
    h('div', { className: 'clf-editor-modal' },
      h('div', { className: 'clf-editor-header' },
        h('div', { className: 'clf-editor-title' }, settingsTitle),
        h('button', { className: 'clf-editor-close', onClick: onClose, title: 'Close' }, '\u00d7')
      ),
      h('div', { className: 'clf-editor-subtitle' },
        'Configure labels for ',
        h('strong', null, title),
        '.'
      ),
      h('div', { className: 'clf-editor-body' },
        h('div', { className: 'clf-editor-field' },
          h('span', { className: 'clf-editor-label' }, labelsTitle),
          h('div', { className: 'clf-editor-tags' },
            labels.map(function(label, i) {
              return h('span', { key: i, className: 'clf-editor-tag' },
                h('span', { className: 'clf-editor-tag-text' }, label),
                h('button', {
                  className: 'clf-editor-tag-remove',
                  onClick: removeLabel.bind(null, i),
                  title: 'Remove'
                }, '\u00d7')
              );
            })
          ),
          h('div', { className: 'clf-editor-add-row' },
            h('input', {
              ref: newLabelRef,
              className: 'clf-editor-input',
              type: 'text',
              placeholder: 'Add label...',
              value: newLabel,
              onChange: function(e) { setNewLabel(e.target.value); },
              onKeyDown: handleKeyDown
            }),
            h('button', {
              className: 'clf-editor-add-btn',
              onClick: addLabel,
              disabled: !newLabel.trim()
            }, '+ Add')
          )
        ),
        !hideInstruction ? h('label', { className: 'clf-editor-field' },
          h('span', { className: 'clf-editor-label' }, 'Instruction'),
          h('textarea', {
            className: 'clf-editor-textarea',
            rows: 3,
            placeholder: 'Optional guidance for the classifier...',
            value: instruction,
            onChange: function(e) { setInstruction(e.target.value); }
          })
        ) : null
      ),
      h('div', { className: 'clf-editor-actions' },
        h('button', { className: 'clf-editor-btn clf-editor-btn-secondary', onClick: onClose }, 'Cancel'),
        h('button', {
          className: 'clf-editor-btn clf-editor-btn-primary',
          onClick: handleSave,
          disabled: !labels.length
        }, 'Save')
      )
    )
  );
}

module.exports = ClassifierEditor;
